import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private prefix: string = '/assets/i18n/',
    private suffix: string = '.json',
    private useCxone: boolean = false
  ) {}

  public getTranslation(lang: string): Observable<any> {
    const fileSuffix = this.useCxone ? `-cxone${this.suffix}` : this.suffix;
    return this.http.get(`${this.prefix}${lang}${fileSuffix}`);
  }
}
